import React, { Component } from "react";
import styled from "styled-components";
import { Config } from "constant";
import { ShowNotice } from "Store";
import NotificationBox from "module-common/NotificationBox";

export default class Trial extends Component {
  state = {
    company: "",
    username: "",
    email: ""
  };
  render() {
    const { company, username, email } = this.state;
    return (
      <Screen>
        <Header>
          <Strong>SIGN UP</Strong> <br />
          Be a part of NolimitCare and have fun with us
        </Header>
        <Panel onSubmit={this.onSubmit}>
          <NotificationBox />
          <Label>Company</Label>
          <Input
            label="Company"
            name="company"
            value={company}
            onChange={e => this.setState({ company: e.target.value })}
          />

          <Label>Username</Label>
          <Input
            label="Username"
            name="username"
            value={username}
            onChange={e => this.setState({ username: e.target.value })}
          />

          <Label>Email</Label>
          <Input
            label="Email"
            name="email"
            value={email}
            type="email"
            onChange={e => this.setState({ email: e.target.value })}
          />
          <Row />

          <SecButton>
            <Backbtn
              type="button"
              onClick={async () => (window.location = "/")}
            >
              Back
            </Backbtn>

            <Register type="Submit">Register</Register>
          </SecButton>
        </Panel>
      </Screen>
    );
  }
  // onSubmit(e) {
  onSubmit = e => {
    e.preventDefault();
    const { company, username, email } = this.state;
    if (company === "") {
      ShowNotice("trial-empty");
    } else {
      fetch(`${Config.apiUrl}/createTrialCare`, {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          company: company,
          username: username,
          email: email
        })
      }).then(response => {
        ShowNotice("trial-success");
      });
    }
  };
}

const Screen = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #edf7f9;
`;

const Header = styled.section`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: none;
  width: 500px;
  height: 90px;
  padding: 20px;
  border-radius: 10px;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  color: #fff;
  text-align: center;
  background: #0c8dbf; /* For browsers that do not support gradients */
  background: -webkit-linear-gradient(
    left,
    #0c8dbf,
    #00bf9c
  ); /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradient(
    right,
    #0c8dbf,
    #00bf9c
  ); /* For Opera 11.1 to 12.0 */
  background: -moz-linear-gradient(
    right,
    #0c8dbf,
    #00bf9c
  ); /* For Firefox 3.6 to 15 */
  background: linear-gradient(to right, #0c8dbf, #00bf9c);
  box-shadow: 0px 8px 5px #a5a5a5;
`;

const Strong = styled.span`
  font-size: 18px;
`;
const Panel = styled.form`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: none;
  width: 500px;
  padding: 60px;
  margin-left: 0px;
  background-color: #edf7f9;
  background: white;
  border-radius: 10px;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  box-shadow: 0px 8px 5px #a5a5a5;
`;
const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: -6px;
  margin-bottom: 40px;
`;

const Label = styled.label`
  color: #a5a5a5;
`;

const Input = styled.input`
  background-color: transparent;
  padding: 8px;
  border: none;
  border-bottom: solid 1px #a5a5a5;
  margin-bottom: 15px;
  color: #a5a5a5;
  font-size: 1rem;
  transition: border 0.3s;
  &:focus {
    outline: none;
    border-bottom: solid 2px #6bbcf4;
  }
`;

const Register = styled.button`
  flex: 1;
  display: inline-flex;
  vertical-align: top;
  align-items: center;
  justify-content: center;
  text-align: center;
  border: none;
  color: white;
  transition: 0.3s;
  cursor: pointer;
  border-radius: 17px;
  white-space: nowrap;
  user-select: none;
  background: #0c8dbf; /* For browsers that do not support gradients */
  background: -webkit-linear-gradient(
    left,
    #0c8dbf,
    #00bf9c
  ); /* For Safari 5.1 to 6.0 */
  background: -o-linear-gradient(
    right,
    #0c8dbf,
    #00bf9c
  ); /* For Opera 11.1 to 12.0 */
  background: -moz-linear-gradient(
    right,
    #0c8dbf,
    #00bf9c
  ); /* For Firefox 3.6 to 15 */
  background: linear-gradient(to right, #0c8dbf, #00bf9c);
  padding: 10px;
  &:focus {
    outline: none;
  }
  &:hover {
    opacity: 0.7;
  }
`;
const Backbtn = Register.extend`
  background: #6c7379;
  margin-right: 10px;
`;
const SecButton = styled.section`
  display: flex;
  flex: 1;
`;



// WEBPACK FOOTER //
// ./src/module-trial/index.js